import React from "react";
import AnswerList from "../../../components/Answer/Check/AnswerList";
import { Wrapper } from "./AnswerCheck.styles";

function AnswerCheck() {
  return (
    <Wrapper>
      <AnswerList />
    </Wrapper>
  );
}

export default AnswerCheck;
